// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"a246c1c6","241":"1b2cd570","448":"380e379f","702":"ccf23f8e","728":"97b27257","878":"ee5b7627"}[chunkId] + ".chunk.js";
};